import { Component, ElementRef, OnInit } from '@angular/core';

import { AdminTitle } from '../../../layout/AdminTitle';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { BaseCatalog } from '../../BaseCatalog';
import { IDeltacastCatalog } from '../../../model/product/tena/deltacast/IDeltacastCatalog.d';
import { LiveStageService } from '../../../environment/LiveStage.service';
import { ObjectIdCrud } from '../../../crud/ObjectIdCrud';
import { PrettySubmitGuard } from 'tridion.web.ui/src/app/angular/save/PrettySubmitGuard';
import sortCatalogs from '../../sortCatalogs';
import { DeltacastCatalogApi } from '../../../api/product/tena/deltacast/DeltacastCatalogApi';

@Component({
    templateUrl: '../../BaseCatalog.component.html',
    providers: [DeltacastCatalogApi]
})
export class DeltacastCatalogComponent extends BaseCatalog<IDeltacastCatalog> implements OnInit {
    constructor(
        private adminTitle: AdminTitle,
        private authService: AuthService,
        elementRef: ElementRef,
        liveStageService: LiveStageService,
        prettySubmitGuard: PrettySubmitGuard,
        private deltacastCatalogApi: DeltacastCatalogApi
    ) {
        super(elementRef, liveStageService, prettySubmitGuard, 'Deltacast');
    }

    ngOnInit() {
        this.adminTitle.setTitle('Catalogs - Deltacast');

        this.filter.observable.subscribe(filter => {
            this.deltacastCatalogApi.getAll().subscribe(catalogs => {
                this.init(sortCatalogs(catalogs));
            });
        });
    }

    protected createCrud() {
        return new ObjectIdCrud(this.deltacastCatalogApi, this.authService);
    }
}
